import type { HeightStopsOf } from "./types";

const pointKey = ({ x, y }: { x: number; y: number }): string => `${x.toFixed(2)},${y.toFixed(2)}`;

// A light wired from its switch passes the switch's position on the way; that is where the cable dips to it.
export const heightStopsOf: HeightStopsOf = ({ waypoints, devices }) => {
  const levelAt = new Map(devices.map((device) => [pointKey(device.at), device.level]));
  return waypoints.slice(1, -1).flatMap((point, offset) => {
    const level = levelAt.get(pointKey(point));
    return level ? [{ index: offset + 1, level }] : [];
  });
};
